exports.apiUrlDev = 'https://ddn001.flimmo.de/api/v2';
exports.apiUrlStage = 'https://ddn001.flimmo.de/api/v2';
exports.apiUrlProd = 'https://ddn001.flimmo.de/api/v2';
